<div class="home-container">
    <p class="bienvenidoHome">Bienvenido(a) {{ nombreUsuario }}</p>
    <img src="./assets/img/fondo.PNG" class="fondoHome" alt="">
</div>
